(function(){
  function ready(f){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',f)}else{f()}}
  function isHome(){try{if(location.pathname==='/')return true;var m=document.getElementById('MainContent');if(m&&m.getAttribute('data-template')==='index')return true;var b=document.body;var c=b&&b.className||'';return c.indexOf('template-index')!==-1}catch(e){return false}}
  function ensureDrawer(){var d=document.getElementById('CartDrawer');if(d)return d;d=document.createElement('dialog');d.id='CartDrawer';d.className='ub2r-cart-drawer';
  // ◀◀ 1. 수정됨: Cart 제목에 총수량 span 추가
  d.innerHTML='<div class="ub2r-cart-panel"><div class="ub2r-cart-header"><span class="ub2r-cart-title">Cart (<span class="ub2r-cart-total-count">0</span>)</span><button type="button" class="ub2r-cart-close" aria-label="Close">×</button></div><div id="CartDrawerContent" class="ub2r-cart-content"></div><div id="CartDrawerFooter" class="ub2r-cart-footer"></div></div>';
  document.body.appendChild(d);return d}
  function money(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format((c||0)/100)}catch(e){return((c||0)/100).toFixed(2)}}
  function esc(s){return(s==null?'':String(s)).replace(/[&<>"']/g,function(m){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[m]})}
  function thumb(u){if(!u)return'';return u.replace(/(\.jpe?g|\.png|\.webp)(\?.*)?$/i,'_200x200$1')}

  var dialog=null,content=null,footer=null,openState=false,loading=false,state={cart:null}
  var linePending={},lineInflight={}

  function fetchCart(){return fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.json()})}
  function changeLine(line,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty}),credentials:'same-origin'}).then(function(r){return r.json()})}

  function overlayInputs(){return Array.prototype.slice.call(document.querySelectorAll('.ub2r-sizes input[data-vid], .ub2r-qa__input[data-variant-id]'))}
  function syncOverlayFromCart(cart){
    try{
      var map={},items=(cart&&cart.items)||[];
      for(var i=0;i<items.length;i++){map[String(items[i].variant_id)]=items[i].quantity}
      var ins=overlayInputs();
      for(var j=0;j<ins.length;j++){
        var id=ins[j].getAttribute('data-vid')||ins[j].getAttribute('data-variant-id');if(!id)continue;
        var nv=map[id]||0;
        if(ins[j].value!==String(nv)){ins[j].value=String(nv);try{ins[j].setAttribute('value',String(nv))}catch(e){}}
        try{ins[j].dispatchEvent(new Event('input',{bubbles:true}))}catch(e){}
        try{ins[j].dispatchEvent(new Event('change',{bubbles:true}))}catch(e){}
      }
    }catch(e){}
  }

  function setHeaderCount(n){
    try{
      // ◀◀ 2. 수정됨: ".ub2r-cart-total-count" 선택자 추가
      var nodes=document.querySelectorAll('.cart-bubble__text-count,[data-cart-count],.cart-count,.header__icon--cart .cart-count,cart-icon .cart-bubble__text-count,.ub2r-header-cart .ub2r-count,.ub2r-cartbtn .ub2r-count,.ub2r-qa__cart-count,#ub2rCartCount,#ub2r-cart-count,[data-count-target="cart"],.ub2r-cart-total-count');
      for(var i=0;i<nodes.length;i++){var el=nodes[i];el.textContent=String(n);if(el.classList){el.classList.remove('hidden','visually-hidden')}if(el.getAttribute&&el.getAttribute('aria-hidden')!=null){el.setAttribute('aria-hidden','false')}}
    }catch(e){}
    try{document.dispatchEvent(new CustomEvent((window.ThemeEvents&&window.ThemeEvents.cartUpdate)||'cart:update',{bubbles:true,detail:{data:{itemCount:n},resource:{item_count:n}}}))}catch(e){}
    try{document.dispatchEvent(new CustomEvent('ub2r:cartcount',{detail:{count:n}}))}catch(e){}
  }

  function cloneCart(c){return JSON.parse(JSON.stringify(c||{items:[],total_price:0,item_count:0}))}
  function recalc(c){var t=0,count=0;for(var i=0;i<c.items.length;i++){var it=c.items[i];var each=(it.price||it.final_price||Math.round((it.final_line_price||0)/Math.max(1,it.quantity||1)));it.final_line_price=each*(it.quantity||0);t+=it.final_line_price;count+=it.quantity||0}c.total_price=t;c.item_count=count;return c}

  function optimisticChange(line,newQty){
    if(!state.cart)return;
    var c=cloneCart(state.cart);var idx=line-1;if(!c.items[idx])return;
    var it=c.items[idx];it.quantity=newQty;if(newQty<=0){c.items.splice(idx,1)}
    recalc(c);renderCart(c)
  }

  function getLineQtyFromState(line){
    if(!state.cart||!state.cart.items)return 0;
    var idx=line-1;return state.cart.items[idx]?state.cart.items[idx].quantity:0
  }

  function processLine(line){
    if(lineInflight[line])return;
    var base=getLineQtyFromState(line);
    var delta=linePending[line]||0;
    if(delta===0)return;
    linePending[line]=0;
    var next=Math.max(0,base+delta);
    lineInflight[line]=true;
    optimisticChange(line,next);
    changeLine(line,next).then(function(c){renderCart(c)}).finally(function(){lineInflight[line]=false;if(linePending[line])processLine(line)})
  }

  function enqueue(line,delta){
    linePending[line]=(linePending[line]||0)+delta;
    processLine(line)
  }

  function renderCart(cart){
    state.cart=cart;
    if(!content||!footer)return;
    content.innerHTML='<div class="ub2r-cart-items"></div>';footer.innerHTML='';
    var wrap=content.querySelector('.ub2r-cart-items');
    if(!cart||!cart.items||!cart.items.length){
      wrap.innerHTML='<div class="ub2r-empty">Your cart is empty.</div>';footer.innerHTML='';
      setHeaderCount(0);
      syncOverlayFromCart({items:[],item_count:0});
      return
    }
    var html='';
    for(var i=0;i<cart.items.length;i++){
      var it=cart.items[i];var line=i+1;
      html+='<div class="ub2r-item" data-line="'+line+'" data-qty="'+it.quantity+'"><img class="ub2r-img" src="'+esc(thumb(it.image))+'" alt=""><div><div class="ub2r-title">'+esc(it.product_title)+'</div><div class="ub2r-variant">'+esc(it.variant_title||'')+'</div><div class="ub2r-row"><div class="ub2r-qty"><button class="ub2r-minus" type="button">−</button><span class="ub2r-q">'+it.quantity+'</span><button class="ub2r-plus" type="button">+</button></div><button class="ub2r-remove" type="button">Remove</button><div class="ub2r-price">'+money(it.final_line_price)+'</div></div></div></div>'
    }
    wrap.innerHTML=html;
    footer.innerHTML='<div class="ub2r-subtotal"><span>Subtotal</span><strong>'+money(cart.total_price)+'</strong></div><a class="ub2r-checkout" href="/checkout">Checkout</a>';
    setHeaderCount(cart.item_count);
    syncOverlayFromCart(cart)
  }

  function render(cart){
    if(loading)return;loading=true;
    if(!content||!footer){dialog=ensureDrawer();content=document.getElementById('CartDrawerContent');footer=document.getElementById('CartDrawerFooter')}
    content.innerHTML='<div class="ub2r-cart-loading">Loading…</div>';(cart?Promise.resolve(cart):fetchCart()).then(function(c){renderCart(c)}).catch(function(){content.innerHTML='<div class="ub2r-cart-error">Failed to load cart.</div>'}).finally(function(){loading=false})
  }

  function open(){dialog=ensureDrawer();content=document.getElementById('CartDrawerContent');footer=document.getElementById('CartDrawerFooter');if(!dialog.open){try{dialog.showModal()}catch(e){dialog.setAttribute('open','open')}}document.documentElement.style.overflow='hidden';openState=true}
  function close(){if(!openState)return;openState=false;try{dialog.close()}catch(e){dialog.removeAttribute('open')}document.documentElement.style.overflow=''}

  function onContent(e){
    if(!content||!content.contains(e.target))return;
    var item=e.target.closest('.ub2r-item');if(!item)return;
    var line=+item.getAttribute('data-line');
    if(e.target.closest('.ub2r-plus')){e.preventDefault();enqueue(line,1)}
    else if(e.target.closest('.ub2r-minus')){e.preventDefault();enqueue(line,-1)}
    else if(e.target.closest('.ub2r-remove')){e.preventDefault();optimisticChange(line,0);changeLine(line,0).then(function(c){renderCart(c)})}
  }

  function isCartActivator(el){
    if(!el)return false;
    var href=el.getAttribute&&el.getAttribute('href')||'';
    var viaIcon=el.tagName&&el.tagName.toLowerCase()==='cart-icon';
    return viaIcon||(el.classList&&el.classList.contains('header-actions__cart-icon'))||href==='/cart'||href.indexOf('/cart?')===0||href.indexOf('/cart#')===0
  }

  function handleActivate(e){
    var t=e.target&&(e.target.closest('a,button,cart-icon,.header-actions__cart-icon'));if(!t)return;
    if(!isCartActivator(t))return;if(!isHome())return;
    e.preventDefault();if(e.stopImmediatePropagation)e.stopImmediatePropagation();e.stopPropagation();
    var up=Array.prototype.slice.call(document.querySelectorAll('.ub2r-sizes input[data-vid], .ub2r-qa__input[data-variant-id]')).reduce(function(m,i){var id=i.getAttribute('data-vid')||i.getAttribute('data-variant-id');if(id){var v=parseInt(i.value||i.getAttribute('value')||'0',10);m[id]=isNaN(v)?0:v}return m},{});
    var keys=Object.keys(up);
    var p=keys.length?fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:up}),credentials:'same-origin'}).then(function(r){return r.json()}):fetchCart();
    p.then(function(c){open();render(c)}).catch(function(){open();render()})
  }

  function bind(){
    ['pointerdown','mousedown','touchstart','click'].forEach(function(tp){document.addEventListener(tp,handleActivate,true)});
    document.addEventListener('click',function(e){if(e.target&&e.target.closest('.ub2r-cart-close')){e.preventDefault();close()}if(dialog&&e.target===dialog){e.preventDefault();close()}});
    document.addEventListener('click',onContent)
  }

  function redirectIfCart(){if(location.pathname==='/cart'){location.replace('/?open_cart=1')}}
  function openIfParam(){try{var u=new URL(location.href);if(isHome()&&u.searchParams.get('open_cart')==='1'){open();render()}}catch(e){}}
  function bridge(){try{window.ub2rOpenCart=function(){open();render()}}catch(e){}try{document.addEventListener('ub2r:openCart',function(){open();render()},{capture:true})}catch(e){}}

  ready(function(){bind();redirectIfCart();openIfParam();bridge()})
})();